import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../PageTemplate/ListFormTemplate";
import { config, fuelTypes, transmission } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";
import { getCookie } from "../../utils/cookieHandler";
import useVehiclesLogic from "./useVehiclesLogic";

export const vehicleStatus = [
  { id: "1", name: "Available" },
  { id: "5", name: "Booked" },
  { id: "2", name: "Unavailable" },
  { id: "3", name: "Rented" },
  { id: "6", name: "Lent" },
  { id: "4", name: "Maintenance" },
  { id: "7", name: "Sold" },
];
export const damageTypeStatus = [
  { id: "1", name: "Fixed" },
  { id: "2", name: "Pending" },
];
const columns = [
  { field: "id", label: "ID", decimalCount: 0, allowSorting: true },
  { field: "plate", label: "Plate", allowSorting: false, showInFilter: true },
  {
    field: "concat",
    label: "Vehicle",
    allowSorting: true,
    concatBy: " - ",
    concat: [
      { field: "brand", subvalue: "name" },
      { field: "model", subvalue: "name" },
      { field: "color", subvalue: "name" },
      { field: "year", decimalCount: 0 },
    ],
  },

  {
    field: "class",
    label: "Category",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
  {
    field: "location",
    label: "Location",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
  {
    field: "partner_vehicle",
    label: "Partner Vehicle",
    allowSorting: true,
    showInFilter: true,
  },
  {
    field: "status",
    label: "Status",
    allowSorting: true,
    type: "status",
    values: {
      Available: "text-green-700 ring-green-600/20 bg-green-50",
      Unavailable: "text-red-700 ring-red-600/20 bg-red-50",
      Rented: "text-yellow-700 ring-yellow-600/20 bg-yellow-50",
      Maintenance: "text-blue-700 ring-blue-600/20 bg-blue-50",
    },
    showInFilter: true,
  },
];

const VehiclesPage = () => {
  const {
    apiRoute,
    tabsData,
    initFields,
    captain,
    admin,
    managerRole,
    operator,
    financeRole,
    rentalPartnerRole,
    clientRole,
  } = useVehiclesLogic();

  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, operator, financeRole, rentalPartnerRole, clientRole];
  const deleteRoles = [admin, managerRole, operator, financeRole];
  const editRoles = [admin, managerRole, operator, financeRole, rentalPartnerRole, clientRole];

  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];
      const promises = [
        fetchDataAndMapToField(config, "vehiclebrands", "brand", temp),
        fetchDataAndMapToField(config, "vehiclemodels", "model", temp),
        fetchDataAndMapToField(config, "vehicleclasses", "class", temp),
        fetchDataAndMapToField(config, "vehicletypes", "type", temp, "Name"),
        fetchDataAndMapToField(config, "colors", "color", temp),
        fetchDataAndMapToField(
          config,
          "fleetlocations",
          "location",
          temp,
          undefined,
          undefined,
          undefined,
          "branch"
        ),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      // All async calls are finished, update state
      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Vehicles" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="vehicle"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        tabsData={tabsData}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
      />
    </div>
  );
};

export default VehiclesPage;
